import { render, staticRenderFns } from "./UsersRetail.vue?vue&type=template&id=ef68af48&scoped=true"
import script from "./UsersRetail.vue?vue&type=script&lang=js"
export * from "./UsersRetail.vue?vue&type=script&lang=js"
import style0 from "./UsersRetail.vue?vue&type=style&index=0&id=ef68af48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef68af48",
  null
  
)

export default component.exports